import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../interfaces/auth";
import { getdivisionThunk } from "../../asyncThunks/scope/scope";


const initialState: defaultState = {
    error: null,
    data: [],
    loading: false,
};

export const getdivision = createSlice({
    name: "getdivision",
    initialState,
    reducers: {
        setScopeData: (state, action) => {
            state.data = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getdivisionThunk.pending, (state, action) => {
            state.error = null;
            state.loading = true;
        });
        builder.addCase(getdivisionThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action.payload;
            } else {
                state.error = action?.payload;
                state.data = [];
            }
            state.loading = false;
        });
        builder.addCase(getdivisionThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = [];
            state.loading = false;
        });
    },

})

export const { setScopeData } = getdivision.actions;

export default getdivision.reducer;